export enum citaStates {
  SCHEDULED,
  DELAYED,
  DONE,
}
